import {TyDot, DotColorEnum} from '@tymbe/ui-primitives'
import { TyTimelineItemContent } from './TyTimelineItemContent';
import { JSX } from 'react';

export type TyTimelineItemProps = {
  dotColor: DotColorEnum;
  title: string;
  note: string;
  createdBy: string;
  action?: JSX.Element;
  dateCreated: string;
  lastItemObserverRef: ((node: HTMLLIElement) => void) | null;
};

export const TyTimelineItem = (tyTimelineItemProps: TyTimelineItemProps) => {
  return (
    <li
      className="mb-10 relative"
      ref={tyTimelineItemProps.lastItemObserverRef}
    >
      <div className="absolute -left-[46px] top-[40px]">
        <TyDot dotColor={tyTimelineItemProps.dotColor} />
      </div>
      <TyTimelineItemContent {...tyTimelineItemProps} />
    </li>
  );
};
